<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>设备列表</h3>
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="handleAdd">添加设备</el-button>
                </el-col>
                <el-col :span="2" >
                    <el-button type="success" @click="handleBack">返回</el-button>
                </el-col>
            </el-row>
        </div>
    
        <el-table :data="fetchList" v-loading="loading" element-loading-text="拼命加载中">
            <el-table-column prop="productId" label="ID">
            </el-table-column>
            <el-table-column prop="deviceId" label="机器序列号">
            </el-table-column>
            <el-table-column prop="productIdentity" label="条形码编码">
            </el-table-column>
            <el-table-column prop="storageName" label="所在仓库">
            </el-table-column>
            <el-table-column inline-template :context="_self" label="状态">
                <div>
                    <span v-if="row.isOnline">上架</span>
                    <span v-else>下架</span>
                </div>
    
            </el-table-column>
            <el-table-column inline-template :context="_self" width="200" label="操作">
                <span>
                    <el-button @click="handleOrder($index, row)" type="text" size="small">查看租赁历史</el-button>
                    <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button>
                    <el-button @click="handleOnline($index, row)" v-if="!row.isOnline" type="text" size="small">上架</el-button>
                    <el-button @click="handleOff($index, row)" v-if="Role === '1' && row.isOnline" type="text" size="small">下架</el-button>
                    <!-- <el-button @click="handleDelete($index, row)" type="text" size="small">删除</el-button> -->
                </span>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="20" layout="total, prev, pager, next" :total="totalNum">
        </el-pagination>
    
        <el-dialog title="租赁历史" :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <el-form-item label="上一个租赁客户ID" label-width="150px">
                    <span>{{form.lastOrderUserId}}</span>
                </el-form-item>
                <el-form-item label="上一个租赁客户姓名" label-width="150px">
                    <span>{{form.lastOrderUsername}}</span>
                </el-form-item>
                <el-form-item label="上一次租赁订单号" label-width="150px">
                    <span>{{form.lastOrderNo}}</span>
                </el-form-item>
                <el-form-item label="发布时间" label-width="150px">
                    <span >{{ new Date(form.created).getFullYear()+'-'+(new Date(form.created).getMonth()+1)+'-'+new Date(form.created).getDate()+' '+new Date(form.created).getHours()+':'+new Date(form.created).getMinutes()+':'+new Date(form.created).getSeconds()}} </span>
                </el-form-item>
                <el-form-item label="累计租赁次数" label-width="150px">
                    <span>{{form.orderCount}}</span>
                </el-form-item>
                <el-form-item label="累计租赁天数" label-width="150px">
                    <span>{{form.dayCount}}</span>
                </el-form-item>
                <el-form-item label="累计租赁资金" label-width="150px">
                    <span>{{form.rentalSum}}</span>
                </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getProducts,
        getStorages,
        deleteProducts,
        getRentHistory,
        patchProducts,
        getProductCount
    } from '../../api/version'
    
    export default {
        data() {
            return {
                Role: sessionStorage.power,
                currentPage: 1,
                totalNum: 0,
                form: {},
                fetchList: [],
                storageArr: [],
                productId: '',
                dialogFormVisible: false,
                loading: true
            }
        },
    
        created() {
            this.productId = this.$route.params.id
            getProductCount(sessionStorage.userId, JSON.stringify({
    
                'productDetailId': this.productId
    
            })).then(res => {
                console.log(res.data)
                this.totalNum = res.data.count
            })
            //获取设备列表
            getProducts(sessionStorage.userId, JSON.stringify({
                'where': {
                    'productDetailId': this.productId
                },
                "limit": 20,
                "skip": 0,
            })).then(res => {
    
                this.loading = false
                res.data.forEach(item => {
                    if (item.productDetailId === this.$route.params.id * 1) {
                        console.log(1)
                        this.fetchList.push(item)
                        this.loading = false
                    }
                })
                //获取仓库数据
                getStorages(sessionStorage.userId).then(res => {
                    this.storageArr = res.data
                    res.data.forEach(item => {
                        this.fetchList.forEach(item2 => {
                            if (item.id === item2.storageId) {
                                item2.storageName = item.storageName
                            }
                        })
                    })
                }, err => {
                    console.log(err)
                })
            })
    
    
    
    
        },
    
        methods: {
            handleBack() {
                this.$router.push('/list')
            },
            handleOnline(index, row) {
                this.$confirm('此操作将该设备设置为上架, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
    
                    patchProducts(sessionStorage.userId, row.productId, {
                        isOnline: true
                    }).then(res => {
                        if (res.data) {
                            row.isOnline = true
                            this.$message({
                                message: '上架成功',
                                type: 'success'
                            });
                        }
                    })
    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消上架'
                    });
                });
    
            },
            handleOff(index, row) {
                this.$confirm('此操作将该设备设置为下架, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
    
                    patchProducts(sessionStorage.userId, row.productId, {
                        isOnline: false
                    }).then(res => {
                        if (res.data) {
                            row.isOnline = false
                            this.$message({
                                message: '下架成功',
                                type: 'success'
                            });
                        }
                    })
    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消下架'
                    });
                });
    
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.loading = true
                getProducts(sessionStorage.userId, JSON.stringify({
                    'where': {
                        'productDetailId': this.productId
                    },
                    "limit": 20,
                    "skip": 20 * (--val),
                })).then(res => {
                    res.data.forEach(item => {
                        if (item.productDetailId === this.$route.params.id * 1) {
                            console.log(1)
                            this.fetchList.push(item)
                            this.loading = false
                        }
                    })
                    //获取仓库数据
                    getStorages(sessionStorage.userId).then(res => {
                        this.storageArr = res.data
                        res.data.forEach(item => {
                            this.fetchList.forEach(item2 => {
                                if (item.id === item2.storageId) {
                                    item2.storageName = item.storageName
                                }
                            })
                        })
                    }, err => {
                        console.log(err)
                    })
                })
            },
            handleAdd() {
                this.$router.push('/addEquipment/' + this.productId)
            },
            handleEdit(index, row) {
                this.$router.push('/editEquipment/' + row.productId)
            },
            handleOrder(index, row) {
                //查看租赁历史
                console.log(row)
                getRentHistory(sessionStorage.userId, row.productId).then(res => {
                    if (res.data) {
                        if (res.data.result) {
                            this.dialogFormVisible = true
                            this.form = res.data.result
                            this.form.created = row.created
    
                        } else {
                            const h = this.$createElement;
                            this.$message({
                                message: h('p', null, [
                                    h('span', null, '暂无租赁历史 '),
                                    h('i', {
                                        style: 'color: teal'
                                    })
                                ])
                            });
                        }
    
                    }
                })
            },
            handleDelete(index, row) {
                console.log(row)
                this.$confirm('此操作将永久删除该设备, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.fetchList.splice(index, 1)
    
                    deleteProducts(row.productId).then(res => {
                        if (res.data) {
                            this.$message({
                                message: '成功删除',
                                type: 'success'
                            });
                        }
                    }, err => {
                        this.$message.error('删除失败')
                    })
    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
    
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// Equipment.vue?46598b5e